import React from 'react'
import DynamicMaster from '../../Components/DynamicMaster/DynamicMaster'

const ComponentMaster = () => {
  return (
   <>
        <DynamicMaster id={6} dashboardId={8} />
   </>
  )
}

export default ComponentMaster
